import * as Yup from 'yup';

export const RecordSchema = Yup.object()
                               .shape({
                                          email: Yup.string()
                                                    .required('Required'),
                                          accountStatus: Yup.string()
                                                            .required('Required'),
                                      });
